export default __webpack_public_path__ + "19ff4d6f107971b25b0887d0cfb1196e.png";